import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UtensilsCrossed, QrCode, History, LogOut, Tags, ReceiptText, Settings as SettingsIcon, Users, BarChart2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import MenuManagement from '../components/admin/MenuManagement';
import CategoryManagement from '../components/admin/CategoryManagement';
import QRCodeManagement from '../components/admin/QRCodeManagement';
import OrderHistory from '../components/admin/OrderHistory';
import Billing from '../components/admin/Billing';
import Settings from '../components/admin/Settings';
import Customers from '../components/admin/Customers';
import Analytics from '../components/admin/Analytics';
import ChatBox from '../components/ChatBox';

const AdminDashboard = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const navigation = [
    { name: 'Menu',          path: '/admin/menu',      icon: UtensilsCrossed },
    { name: 'Categories',    path: '/admin/categories', icon: Tags },
    { name: 'QR Codes',      path: '/admin/qr-codes',  icon: QrCode },
    { name: 'Billing',       path: '/admin/billing',   icon: ReceiptText },
    { name: 'Order History', path: '/admin/orders',    icon: History },
    { name: 'Customers',     path: '/admin/customers', icon: Users },
    { name: 'Analytics',     path: '/admin/analytics', icon: BarChart2 },
    { name: 'Settings',      path: '/admin/settings',  icon: SettingsIcon },
  ];

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex">
      {/* Sidebar */}
      <div className="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">Admin Panel</h1>
          <p className="text-sm text-gray-600 mt-1">Restaurant Management</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navigation.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg font-medium transition ${
                  isActive ? 'bg-[#E65100] text-white' : 'text-gray-700 hover:bg-gray-100'
                }`}
                data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <Icon className="w-5 h-5" />
                {item.name}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-200">
          <Button variant="outline" onClick={logout} className="w-full justify-start" data-testid="admin-logout-button">
            <LogOut className="w-5 h-5 mr-3" />
            Logout
          </Button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <div className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="/menu"       element={<MenuManagement />} />
            <Route path="/categories" element={<CategoryManagement />} />
            <Route path="/qr-codes"   element={<QRCodeManagement />} />
            <Route path="/billing"    element={<Billing />} />
            <Route path="/orders"     element={<OrderHistory />} />
            <Route path="/customers"  element={<Customers />} />
            <Route path="/analytics"  element={<Analytics />} />
            <Route path="/settings"   element={<Settings />} />
            <Route path="/"           element={<MenuManagement />} />
          </Routes>
        </div>

        {/* Chat Footer */}
        <div className="border-t border-gray-200 bg-white">
          <div className="max-w-7xl mx-auto">
            <ChatBox role="admin" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
